/**
 * Utility module for handling message formatting and processing
 */

/**
 * Format message text with markdown-like syntax
 * @param {string} text - The message text to format
 * @returns {string} Formatted HTML text
 */
export const formatMessage = (text) => {
	if (!text) return '';

	// Bold: **text** or __text__
	text = text.replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>');

	// Italic: *text* or _text_
	text = text.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');

	// Code blocks: ```code```
	text = text.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');

	// Inline code: `code`
	text = text.replace(/`([^`]+)`/g, '<code>$1</code>');

	// Links: [title](url)
	text = text.replace(
		/\[([^\]]+)\]\(([^)]+)\)/g,
		'<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
	);

	// Convert line breaks to <br>
	text = text.replace(/\n/g, '<br />');

	return text;
};

/**
 * Parse message text for UI components like buttons
 * @param {string} text - The message text to parse
 * @param {Function} onAction - Function to call when an action is triggered
 * @returns {Object} Object with parsed text and any actions
 */
export const parseMessageComponents = (text) => {
	if (!text) return { text: '', hasComponents: false };

	let hasComponents = false;

	// Find button components: <Button title="Title" onPress={() => {sendMessage("message")}} />
	const buttonRegex =
		/<Button title="([^"]+)" onPress={\(\) => {sendMessage\("([^"]+)"\)}} \/>/g;

	// Replace button syntax with actual HTML buttons
	text = text.replace(buttonRegex, (match, title, message) => {
		hasComponents = true;
		return `<button class="message-action-button" data-message="${message}">${title}</button>`;
	});

	return {
		text,
		hasComponents,
	};
};
